<template>
  <a-modal v-model="visible" width="1100px" title="请选择货品" :destroy-on-close="true" :footer="null" centered @ok="confirm">
    <div class="chooseGoods"></div>
    <a-form-model :model="form" :rules="rules" layout="inline">
      <a-form-model-item ref="skuCode" :colon="false" label="货主货品编码" prop="skuCode">
        <a-input v-model="form.skuCode" placeholder="请输入" @pressEnter="searchList" />
      </a-form-model-item>
      <a-form-model-item ref="skuName" :colon="false" label="货品名称" prop="skuName">
        <a-input v-model="form.skuName" placeholder="请输入" @pressEnter="searchList" />
      </a-form-model-item>
      <a-form-model-item ref="temperatureZone" :colon="false" label="温区" prop="temperatureZone">
        <a-select
          v-model="form.temperatureZone"
          style="width: 120px"
          :get-popup-container="triggerNode => triggerNode.parentNode"
        >
          <a-select-option
            v-for="(temp, i) in TEMPERATURES"
            :key="i"
            :value="temp.value"
          >{{temp.label}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item ref="goodsLevel" :colon="false" label="货品三级分类" prop="goodsLevel">
        <a-cascader
          v-model="form.goodsLevel"
          allow-clear
          change-on-select
          :options="levelOptions"
          :field-names="{
            label: 'name',
            value: 'name',
            children: 'children'
          }"
          placeholder="请选择货品三级分类" />
      </a-form-model-item>
      <a-form-model-item label="其它" :colon="false">
        <!-- <a-checkbox v-model="form.latestUsed">最近使用</a-checkbox> -->
        <a-checkbox v-model="form.usualUsed">常用</a-checkbox>
      </a-form-model-item>
      <a-form-model-item>
        <a-button class="goodsSelectStyle" type="primary" @click="searchList">查询</a-button>
      </a-form-model-item>
      <a-form-model-item>
        <a-checkbox v-model="checked">最近使用</a-checkbox>
      </a-form-model-item>
    </a-form-model>
    <div class="tips">
      <span>最多选择50个货品，超过50个建议使用 </span>
      <span class="link" @click="toBatch">批量导入下单</span>
    </div>
    <div class="tablebox">
      <a-table
        :columns="goodsTableListColumns"
        :data-source="goodsAllList"
        :pagination="checked?false:pagination"
        class="goods-table table-sigle"
        :custom-row="onclickRow"
        row-key="id"
        :scroll="{ x: 'calc(800px + 50%)', y: '40vh'}"
        :row-selection="{
          onSelect,onSelectAll,
          onChange,
          selectedRowKeys,
          getCheckboxProps,
      }"
        @change="tableChange"
      >
        <template v-for="col in ['skuCode', 'norms']" :slot="col" slot-scope="text">
          <a-tooltip :key="col" placement="top">
            {{ text }}
            <template slot="title">{{ text }}</template>
          </a-tooltip>
        </template>
        <template slot="skuName" slot-scope="text, rowData">
          <a-tooltip placement="top">
            <span v-if="proving(rowData, UsageStatus.RECENTUSE, 'latestUsed')" class="latelyStyle">最近使用</span>
            <span v-if="proving(rowData, UsageStatus.COMMONLY_USED, 'usualUsed')" class="oftenStyle">常用</span>
            <!-- <img src="@/assets/img/icon_lately.png" style="width:30px" alt=""> -->
            {{ text }}
            <template slot="title">{{ text }}</template>
          </a-tooltip>
        </template>
        <template slot="goodsPrice" slot-scope="text">
          {{ text ? `${text}.00` : ''}}
        </template>
      </a-table>
    </div>
    <a-row>
      <a-col :span="12">
        <p :class="goodsAllList.length > 0 && !checked? 'addTips activeStyle' :'addTips'">
          <span>没有想要的货品？</span>
          <span @click="toAddGoods">新建货品</span>
        </p>
      </a-col>
        <a-col :span="12">
            <a-button class="boxBtn" type="primary" @click="yesSelect">选好了</a-button>
            <a-button class="boxBtn" @click="confirm">取消</a-button>
        </a-col>
    </a-row>
    <AddGoods ref="addGoods" @create="searchList"></AddGoods>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import {SKU_RULE_PARAMS} from '@/constants/ruleConfig'
import { goodsTableListColumns } from "../goodsTable";
import AddGoods from './AddGoods'
import { fetchSkuPage, fetchSkuPageV2,getLevelTree } from '../api'

const UsageStatus = {
  RECENTUSE: 1,
  COMMONLY_USED: 1
}

const TEMPERATURES = [
  {
    value: "",
    label: "全部",
  },
  {
    value: "常温",
    label: "常温",
  },
  {
    value: "冷藏",
    label: "冷藏",
  },
  {
    value: "冷冻",
    label: "冷冻",
  },
  {
    value: "自定义温区",
    label: "自定义温区",
  },
];
const MAX_GOODS_NUMBER = 50;

export default {
  name: "ChooseGoods",
  components: {
      AddGoods
  },
  props: {
    isPretend: {
      type: Boolean,
      default: false
    },
  },
  inject: ['order'],
  data() {
    return {
      UsageStatus,
      visible: false,
      pageSize: 10,
      goodsTableListColumns,
      goodsAllList: [],
      form: {
        skuCode: null,
        skuName: null,
        temperatureZone: "",
        latestUsed: false,
        usualUsed: false,
        goodsLevel: null,
      },
      rules: {
        skuCode: [],
      },
      TEMPERATURES,
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        onShowSizeChange: (current, pageSize) => {(this.pageSize = pageSize)},
        showQuickJumper: true,
        showTotal: (total) => `已选${this.selectedRowKeys.length}条 共 ${total} 条`,
      },
      selectedRows: [],
      selectedRowKeys: [],
      levelOptions: [],
      checked:false, // 最近使用
    };
  },
  computed: {
    ...mapState('orderRules', ['orderRules']),
  },
  watch:{
    checked:{
      handler(val){
        if(!val){
          this.pageSize=10;
          this.pagination={
            current: 1,
            total: 0,
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30", "40", "50"],
            onShowSizeChange: (current, pageSize) => {(this.pageSize = pageSize)},
            showQuickJumper: true,
            showTotal: (total) => `已选${this.selectedRowKeys.length}条 共 ${total} 条`,
          }
        }
        this.searchList();
      },
      immediate:true
    }
  },
  async created() {
    this.levelOptions = await getLevelTree();
  },
  mounted() {},
  methods: {
    filterData(data, value){
      return data === value ? null : data
    },
    proving(rowData, type, name) {
      if (name === 'usualUsed' && rowData.ext && rowData.ext.usualUsed && rowData.ext.usualUsed === type ) {
        return true
      }
      if (name === 'latestUsed' && rowData.ext && rowData.ext.latestUsed && rowData.ext.latestUsed === type ) {
        return true
      }
      return false
    },
    searchList(){
      this.pagination.current = 1;
      this.getList()
    },
    async getList() {
      const { goodsLevel } = this.form;
      const {scope} = this.orderRules.SKU_RANGE;
      const data = {
        ...SKU_RULE_PARAMS(scope),
        usualUsed: this.filterData(this.form.usualUsed, false), // 是否常用
        latestUsed: this.filterData(this.form.latestUsed, false), // 是否最近使用
        temperatureZone: this.filterData(this.form.temperatureZone, ''),
        skuName: this.filterData(this.form.skuName, ''),
        skuCode: this.filterData(this.form.skuCode, ''),
        status: 1,
        deleteStatus: 0,
        ignoreTenantId: true, // 是否忽略租户id
        goodsLevel1: goodsLevel?.[0],
        goodsLevel2: goodsLevel?.[1],
        goodsLevel3: goodsLevel?.[2],
      }
      // 最近使用
      if(this.checked){
        const record=await fetchSkuPageV2(data);
        this.goodsAllList=record;
        this.pageSize=record.length
        this.pagination={
          current:1,
          defaultPageSize: record.length,
          pageSizeOptions:[],
          showSizeChanger: false,
          showQuickJumper: false,
          total:record.length
        }
        return
      }
      // 之前
      const params = {
            size: this.pageSize,
            page: this.pagination.current
        }
      fetchSkuPage(data, params).then((res) => {
        this.goodsAllList = res.records
        this.pagination.total = res.total
      })
    },
    yesSelect() {
      const arr = []
      // 当SKU未维护重量或体积时，表单无数据，报错不能提交
      const notInfo = this.selectedRows.filter(item => !item.weight || !item.volume)
      if (notInfo.length) {
        this.$message.warning('货品未维护单位重量或体积，请维护后重试')
        return
      }
      this.selectedRows.forEach((e) => {
        this.selectedRowKeys.forEach((res)=>{
          if (res === e.id) {
            arr.push(e)
          }
        })
      })
      this.$emit('change', arr)
      this.confirm()
    },
    confirm() {
      this.visible = false;
      this.form.skuCode = null;
      this.form.skuName = null;
      this.form.temperatureZone = "";
      this.form.latestUsed = false;
      this.form.usualUsed = false;
      this.form.goodsLevel = null;
      this.pageSize = 10;
      this.pagination.current = 1;
    },
    show(goods) {
      this.visible = true;
      this.checked=false;
      this.getList();
      if(this.isPretend){
        this.selectedRowKeys = [];
        this.selectedRows = []
      } else {
        const keyArry = [];
        goods.forEach((e) => {
          keyArry.push(e.skuId);
        })
        this.selectedRowKeys = keyArry;
        this.selectedRows = goods.map(e => {
          const res = e.skuNorms.split('/')
          return {
            ...e,
            id: e.skuId,
            norms: res[0],
            unit: e.skuUnit,
            goodsPrice: e.goodsValue,
          };
        })
      }
    },
    onclickRow(record) {
      return {
        on: {
            click: () => {
              const {ext = {}} = record
              const {goodsLevel1, goodsLevel2, goodsLevel3} = ext
              const { levelParams } = this.order
              if (levelParams && !levelParams[goodsLevel1]?.[goodsLevel2]?.[goodsLevel3]) {
                return
              }
              if (!this.selectedRowKeys.includes(record.id)) {
                this.selectedRowKeys.push(record.id)
                this.selectedRows.push(record)
              } else {
                const index = this.selectedRowKeys.indexOf(record.id)
                this.selectedRowKeys.splice(index, 1)
                this.selectedRows.splice(index, 1)
              }
            }
        }
      }
    },
    onSelect(record, selected) {
      if (selected) {
        const goodsNumber = this.selectedRows.length
        if (goodsNumber >= MAX_GOODS_NUMBER) {
          this.$message({ type: "info", message: "最多可选择50个货品" });
        } else {
          this.selectedRows.push(record)
        }
      }
      if (!selected) {
        this.remove(record)
      }
    },
    // 合同已配置分类,仅可选择合同配置三级分类下的SKU
    // 合同未配置分类,可以选择全量货品库SKU
    getCheckboxProps(record) {
      const {ext} = record
      const {goodsLevel1, goodsLevel2, goodsLevel3} = ext || {}
      const { levelParams } = this.order
      return {
        props: {
          disabled: levelParams ? !levelParams[goodsLevel1]?.[goodsLevel2]?.[goodsLevel3] : false,
        }
      }
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        const goodsNumber = this.selectedRows.length + changeRows.length
        if (goodsNumber > MAX_GOODS_NUMBER) {
          this.$message({ type: "info", message: "最多可选择50个货品" });
        } else {
          this.selectedRows.push(...changeRows)
        }
      }
      if (!selected) {
        changeRows.forEach((e) => {
          this.remove(e)
        })
      }
    },
    onChange(selectedRowKeys){
      this.selectedRowKeys = selectedRowKeys
    },
    remove(record) {
      this.selectedRows = this.selectedRows.filter((e) => {
        return e.id !== record.id
      })
    },
    toAddGoods() {
        this.$refs.addGoods.show()
    },
    toBatch() {
        this.$router.push({
          path: '/order/create-multiple'
        })
    },
    tableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
      };
      this.getList()
    },
  },
};
</script>

<style lang="less" scoped>
.tips {
  font-size: 12px;
  color: red;
  margin: 5px 0 10px;
  .link {
    text-decoration: underline;
    color: #adadad;
    cursor: pointer;
  }
}
.tablebox {
  max-height: 60vh;
  overflow-y: scroll;
  margin-bottom: 10px;
  position: relative;
  /deep/ .ant-table{
      font-size: 12px !important;
      .ant-table-thead ,.ant-table-scroll{
          background-color: #f5f5f5;
      }
      .ant-table-column-title{
        font-weight: bold;
      }
  }
}
.addTips {
    // position: absolute;
    // left: 0;
    // bottom: 22px;
    font-size: 14px;
    color: #aaaaaa;
    span:last-child {
      color: #06b880;
      text-decoration: underline;
      &:hover {
        cursor: pointer;
      }
    }
  }
.latelyStyle {
  display: inline-block;
  margin-right: 5px;
  padding: 0 5px;
  border: 1px solid red;
  color: red;
  font-size: 12px;
  border-radius: 5px;
}
.oftenStyle {
  display: inline-block;
  margin-right: 5px;
  padding: 0 5px;
  border: 1px solid #1890ff;
  color: #1890ff;
  font-size: 12px;
  border-radius: 5px;
}
.boxBtn{
    float: right;
    margin-left: 20px;
}
.activeStyle{
  position:absolute;
  top: -43px;
  left: 0;
}
/deep/ .ant-table-row{
  &:hover{
    cursor: pointer;
  }
}
</style>